import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function updateFactura (params = null, data = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getNotificationstatus)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/facturas/updatefactura',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updateFactura }
